import roadmapSprite from '@/assets/sprite/roadmap-sprite.svg';
import { GameResult as GameResultEnum } from '@/models/games/roulette/GameResult';
import { isBitActive } from '@/utils/bitwiseUtil';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { useMemo } from 'react';
import { GameResultCellProps } from '..';

export const UltraRouletteGameResult = (props: GameResultCellProps) => {
    const { summary } = props;
    const result = useMemo(() => {
        return JSON.parse(summary.Result);
    }, [summary.Result]);
    const color = useMemo(() => {
        if (isBitActive(summary.WinSlot, GameResultEnum.RRZero)) {
            return '#FF4F4F';
        } else if (isBitActive(summary.WinSlot, GameResultEnum.RRRed)) {
            return '#c70000';
        } else if (isBitActive(summary.WinSlot, GameResultEnum.RRBlack)) {
            return '#6C6C6C';
        }
    }, [summary.WinSlot]);

    const hasMultipier = useMemo(() => result.RM > 3000, [result]);

    return (
        <>
            <Stack className="item-ultra-roulette-game-result-container">
                {hasMultipier && (
                    <Box className="bet-record-multipier-result-container">
                        <Box bgcolor={color} className="result-container">
                            {result.R}
                        </Box>
                        <Box className="multipier-svg-label-container">
                            <svg width="100%" height="100%">
                                <use
                                    xlinkHref={`${roadmapSprite}#roulette__ultra_multipier__${result.RM}`}
                                    key={`${result.RM}-label`}
                                />
                            </svg>
                        </Box>
                    </Box>
                )}
                {!hasMultipier && (
                    <Box bgcolor={color} className="result-container">
                        {result.R}
                    </Box>
                )}
            </Stack>
        </>
    );
};
